import DocumentTemplate from '@/components/ui/document-template/DocumentTemplate'

const preambleContent = [
	{
		text: (
			<p>
				Pepper DAO is created by the community, for the community. We are the Pepper People, a united movement
				within the Chiliz Ecosystem, building a future that’s transparent, fun, and spicy just like the Pepper
				community!
			</p>
		)
	},
	{
		text: (
			<p>
				As $PEPPER becomes the platform token of{' '}
				<a href="https://www.kayen.finance/" target="_blank" rel="noopener noreferrer" className="underline">
					Kayen.finance
				</a>
				, this constitution is the shared promise to grow together, protect the $PEPPER economy, and ensure{' '}
				<strong>every voice matters</strong>.
			</p>
		)
	}
]

const articleIContent = [
	{
		title: '1.1 Who We Are',
		text: (
			<p>
				Pepper DAO is a decentralized community-powered organization within the Chiliz ecosystem. As $PEPPER
				holders, this is not a corporate office; this is a parliament of participation, a decentralized
				governance spread all around the world that coordinates actions seamlessly through the DAO portal.
			</p>
		)
	},
	{
		title: '1.2 Regulatory Classification',
		text: (
			<p>
				<strong>Fair Launch Validation:</strong> The $PEPPER airdrop does not constitute an "investment of
				money" under the Howey test, as recipients provided no money, goods, or services in exchange for the
				asset.
				<br />
				<strong>Decentralized Value:</strong> As a community-driven project without a central party overseeing
				rewards, $PEPPER’s value is derived from supply, demand, and community utility rather than the
				managerial efforts of others.
			</p>
		)
	},
	{
		title: '1.3 Tokenomics & Supply',
		text: (
			<p>
				The $PEPPER token is designed as a high-supply community asset to ensure the maximum distribution and
				engagement.
				<br />
				<br />• <strong>Total Supply:</strong> Fixed at 8,888,888,888,000,000 PEPPER (8,888.8 Quadrillion)
				$PEPPER
				<br />• <strong>ve-Governance:</strong> The governance system utilized is the{' '}
				<a
					href="https://docs.aragon.org/ve-governance/1.0.0"
					target="_blank"
					rel="noopener noreferrer"
					className="underline"
				>
					Aragon veLocker
				</a>
				. Locking $PEPPER grants vePEPPER voting power; longer locks yield more voting power via the Curve
				ve-model.
				<br />• <strong>The Buyback Engine:</strong> As the platform token of Kayen.finance and to keep the
				ecosystem healthy, <strong>25% of the DEX fees</strong> (from trades) from Kayen.finance go directly
				toward buying back & burning $PEPPER (50% for treasury and 50% for burn).
			</p>
		)
	},
	{
		title: '1.4 Purpose',
		text: (
			<p>
				<strong>Pepper DAO</strong> is the hub where things matter for the community, where momentum is created
				and where ideas turn into real actions. Through the DAO portal $PEPPER holders will be able to:
				<br />
				<br />
				• Vote to elect their Ministers
				<br />
				• Create a proposal to support the growth of the community
				<br />
				• Support community-led initiatives
				<br />
				• Make themselves heard by everyone
				<br />• Manage & safeguard the $PEPPER treasury
			</p>
		)
	}
]

const articleIIContent = [
	{
		text: (
			<p>
				Every $PEPPER holder can be a member of the DAO and has the following rights:
				<br />
				<br />• <strong>Governance Access:</strong> Every holder has the right to vote on proposals, community
				incentives and a series of decisions regarding PepperDAO and Kayen.Finance, including determining which
				Liquidity Pools (LPs) on Kayen.Finance receive Yield Promotions.
				<br />• <strong>Proposal Submission:</strong> Formal proposals require the threshold defined in Article
				IV.
				<br />• <strong>Early Access:</strong> Members may receive "First Look" beta access to features like
				limit orders and perpetuals on Kayen.
			</p>
		)
	}
]

const articleIIIContent = [
	{
		title: '3.1 The Ministers',
		text: (
			<p>
				We elect <strong>three (3) Ministers</strong> to organize the vibes and the votes.
				<br />
				<br />
				<strong>The Pillars:</strong> Prime Minister, Treasury Minister, Publicity Minister
				<br />
				<br />
				The roles for the 3 elected ministers:
				<br />
				<br />• <strong>Prime Minister</strong> — Coordinates governance processes, schedules votes, and ensures
				communication flow.
				<br />• <strong>Treasury Minister</strong> — Manages the treasury, spending, and financial reporting.
				<br />• <strong>Publicity Minister</strong> — Manages Pepper's social media day-to-day: content posting,
				community amplification, announcements, and growth across Pepper's official channels.
			</p>
		)
	},
	{
		title: '3.2 Ministerial Code of Conduct',
		text: (
			<p>
				All elected Ministers must adhere to the following ethical standards to remain in office:
				<br />
				<br />
				1. <strong>Integrity & Honesty:</strong> Ministers must act with total honesty and never use their
				position for personal financial gain or private "side deals".
				<br />
				2. <strong>Transparency:</strong> Ministers must provide mandatory monthly reports on their activities
				and spending. Missing three reports triggers an automatic confidence vote.
				<br />
				3. <strong>Constitutional Fidelity:</strong> Ministers are bound to protect the "Red Lines" and the core
				principles of the Pepper DAO.
				<br />
				4. <strong>No Gatekeeping:</strong> Ministers must encourage open participation and avoid any elitist
				behavior.
				<br />
				5. <strong>Professional Conflict Management:</strong> Ministers must disclose any conflict of interest
				that may prevent them from acting in the DAO’s best interests, abstain or recuse themselves where
				appropriate, and avoid participating in related discussions.
				<br />
				6. <strong>Removal:</strong> Ministers can be removed at any time by a 60% community vote if they fail
				to uphold these standards.
			</p>
		)
	}
]

const articleIVContent = [
	{
		text: <p>We use a simple, transparent process on the DAO Portal.</p>
	},
	{
		title: '4.1 The Proposal Threshold',
		text: (
			<p>
				To prevent "spam", the minimum token threshold is{' '}
				<strong>1,000,000,000,000 (1 Trillion) $PEPPER staked</strong> to submit a formal on-chain proposal.
				This is technically enforced via the Aragon threshold plugin.
			</p>
		)
	},
	{
		title: '4.2 The Voting Cycle',
		text: (
			<p>
				Voting periods are hard-coded into smart contract tracks to match a proposal's significance:
				<br />
				<br />• <strong>Standard Track (7 Days):</strong> Major treasury spending, protocol parameter changes,
				or Ministerial elections.
				<br />• <strong>Agile Track (3 Days):</strong> Community initiatives and minor operational adjustments.
				<br />• <strong>Fast Track (48 Hours):</strong> Reserved for Critical Needs (security patches) or Urgent
				Treasury Requests (time-sensitive partnerships), requiring a <strong>66% quorum</strong> to pass.
			</p>
		)
	},
	{
		title: '4.3 Fast Track Definitions',
		text: (
			<p>
				a) <strong>Urgent Treasury Request:</strong> Defined as time-sensitive strategic opportunities (i.e.
				partnership deals with expiration dates, token listings with a deadline payment) or emergency liquidity
				injections required to maintain market stability.
				<br />
				b) <strong>Critical Operational Needs:</strong> Defined as security hotfixes related emergencies.
			</p>
		)
	}
]

const articleVContent = [
	{
		text: (
			<p>
				These points are the fundamental safeguards of the ecosystem and cannot be altered by standard community
				proposals.
			</p>
		)
	},
	{
		title: '5.1 Protection of The DAO',
		text: (
			<p>
				• <strong>Inflation Cadence:</strong> The permanent Community/Pepper allocation must be spent gradually
				and strategically to avoid hurting the token and the project’s health.
				<br />• <strong>Core Protocol Rules:</strong> Voters cannot stop or fundamentally change the automated
				Buyback & Burn Engine.
				<br />• <strong>Treasury Limits:</strong> Any single vote spending above a community-set threshold
				requires a 66% super-majority.
			</p>
		)
	}
]

const articleVIContent = [
	{
		text: (
			<p>
				The DAO treasury comes from the Community/Pepper allocation and potential future partnerships.
				<br />
				<br />
				How the Community/Pepper allocation should be used is subject to the decisions from PepperDAO.
				<br />
				<br />
				Pepper people believe in transparency over secrecy, this is why every penny spent is visible for all to
				see and no hidden deals or private spending are permitted.
			</p>
		)
	}
]

const Constitution = () => (
	<DocumentTemplate
		title="Constitution"
		contentBuckets={[
			{ bucketTitle: 'Preamble', className: 'bg-green-10', content: preambleContent },
			{ bucketTitle: 'Article I: Identity, Purpose & Power', className: 'bg-green-20', content: articleIContent },
			{ bucketTitle: 'Article II: Pepper People Rights', className: 'bg-green-10', content: articleIIContent },
			{ bucketTitle: 'Article III: The Pepper Parliament', className: 'bg-green-20', content: articleIIIContent },
			{ bucketTitle: 'Article IV: Governance & Voting', className: 'bg-green-10', content: articleIVContent },
			{ bucketTitle: 'Article V: The “Red Lines”', className: 'bg-green-20', content: articleVContent },
			{ bucketTitle: 'Article VI: Treasury and Growth', className: 'bg-green-10', content: articleVIContent }
		]}
	/>
)

export default Constitution
